import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import App from './App';
import './index.css';
// "Clay Studio" theme (Bento + Claymorphism), shared by the cloud portal and
// the Server EXE. clay-theme.css is scoped under html.clay (applied always);
// exe-clay.css adds the EXE-only window-drag region and lab type scale.
import './clay-theme.css';
import './exe-clay.css';
import { initTheme } from './lib/theme';

// Apply the persisted theme before the first paint so there's no flash of
// the wrong theme while React mounts.
initTheme();

// Font Imports for Offline Support
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';

const isElectronRuntime = typeof window !== 'undefined' && !!window.examClient?.server?.localApiCall;
const Router = isElectronRuntime ? HashRouter : BrowserRouter;

// Activate the "Clay Studio" theme (Bento + Claymorphism) before the first
// React paint so there is no flash of unstyled/legacy chrome. The cloud portal
// and the EXE share the skin; the EXE adds its own window-chrome extras.
document.documentElement.classList.add('clay');
if (isElectronRuntime) {
    document.documentElement.classList.add('exe-clay');
}

if (typeof window !== 'undefined' && !isElectronRuntime) {
    const supportsServiceWorker = 'serviceWorker' in navigator;
    const isHttpProtocol = window.location.protocol === 'http:' || window.location.protocol === 'https:';
    if (supportsServiceWorker && isHttpProtocol) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/sw.js').catch(() => {});
        });
    }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <Router>
            <App />
        </Router>
    </React.StrictMode>
);
